import { render, staticRenderFns } from "./AddNewCanteenDialog.vue?vue&type=template&id=9d9a7bc8&dir=auto&"
import script from "./AddNewCanteenDialog.vue?vue&type=script&lang=js&"
export * from "./AddNewCanteenDialog.vue?vue&type=script&lang=js&"
import style0 from "./AddNewCanteenDialog.vue?vue&type=style&index=0&id=9d9a7bc8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports